"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleApiError = void 0;
const ApiErrorSerializers_1 = require("@deliverr/commons-logs/lib/ApiErrorSerializers");
const _ = require("lodash");
function handleApiError(ex, defaultError, failedFn, timedOutFn = failedFn, unhandledFn = failedFn, failedStatusCodes = [400, 404, 422, 500, 503], timedOutStatusCodes = [504]) {
    const responseData = _.get(ex, "response.data");
    const httpStatusCode = _.get(ex, "response.status");
    const error = Object.assign(Object.assign({}, defaultError), { payload: Object.assign(Object.assign({}, (0, ApiErrorSerializers_1.apiErrorSerializer)(ex)), { responseData }) });
    let data;
    if (httpStatusCode === undefined) {
        switch (ex.code) {
            case "ECONNREFUSED":
                data = failedFn();
                break;
            case "ECONNABORTED":
            case "ECONNRESET":
                data = timedOutFn();
                break;
            default:
                data = unhandledFn();
                break;
        }
    }
    else if (failedStatusCodes.includes(httpStatusCode)) {
        data = failedFn();
    }
    else if (timedOutStatusCodes.includes(httpStatusCode)) {
        data = timedOutFn();
    }
    else {
        data = unhandledFn();
    }
    return { data, error };
}
exports.handleApiError = handleApiError;
//# sourceMappingURL=ApiErrorHandler.js.map